import { UserFragment } from '@school_ify/schoolify-repository/src/shared/types';

import { AuthActions } from './actions';
import { authenticationTypes } from './types';

const { SIGN_UP } = authenticationTypes;

interface AuthState {
  user: UserFragment | null | undefined;
  isLoggedIn: boolean;
}

export const initialState: AuthState = {
  user: null,
  isLoggedIn: false,
};

// eslint-disable-next-line default-param-last
const authenticationReducer = (state = initialState, action: AuthActions): AuthState => {
  switch (action.type) {
    case SIGN_UP: {
      return {
        ...state,
        user: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default authenticationReducer;
